// extracted by mini-css-extract-plugin
export default {"mobileTabs":"mobileTabs__gmHZ5","active":"active__4RpMQ","badge":"badge__n7y-i"};